import PackageAddStandFormForm from './package-add-stand-form'

export default PackageAddStandFormForm;